import React from 'react';
import { Instagram, Facebook, Linkedin } from 'lucide-react';
import { useSocials } from '../data';

const ICONS = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin };
const LABELS = { instagram: 'Instagram', facebook: 'Facebook', linkedin: 'LinkedIn' };

/*
 * Row of social links (SPEC §5/§6/§7.1.4).
 *   variant: 'plain' (line icons) | 'chips' (rounded squares, footer)
 *   order:   which platforms and in what order (defaults to nav order)
 */
export default function SocialRow({
  variant = 'plain',
  order = ['facebook', 'linkedin'],
  size = 18,
  socials,
}) {
  const fromContext = useSocials();
  const urls = socials || fromContext;
  return (
    <div className={`social-row${variant === 'chips' ? ' social-row--chips' : ''}`}>
      {order.map((key) => {
        const Icon = ICONS[key];
        if (!Icon) return null;
        return (
          <a
            key={key}
            className="social-row__link"
            href={urls[key] || '#'}
            aria-label={LABELS[key]}
            target={urls[key] && urls[key] !== '#' ? '_blank' : undefined}
            rel={urls[key] && urls[key] !== '#' ? 'noopener noreferrer' : undefined}
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
}
